import React, { ChangeEvent, useEffect, useState } from 'react';
import {
  Card,
  Grid,
  Tooltip,
  Checkbox,
  FormControlLabel,
  FormGroup,
} from '@material-ui/core';
import { uniqueId, isEmpty } from 'lodash';
import { IntlShape, injectIntl } from 'react-intl';
import { StyledTitleRoles } from 'containers/AttributionManager/styles';
import messages from 'containers/AttributionManager/messages';
import { translate } from 'containers/services/translate';
import {
  StyledCard,
  StyledSpan,
  StyledToolTip,
  StyledSpacingGrid,
  StyledSpacing,
} from 'containers/AttributionManager/styles';
import {
  extractInboxesByUserId,
  constructTitleOfInboxes,
} from 'containers/AttributionManager/utils';
import ConfirmationDialog from 'containers/AttributionManager/Dialogs/ConfirmationDialog';
import AssignedManagerInboxes from 'containers/AttributionManager/Dialogs/AssignedManagerInboxes';
import closeIcon from 'images/cancel.svg';
import currentUserStorage from 'containers/services/security/current-user-storage';

export interface AssignedManagerProps {
  intl: IntlShape;
  List: any;
  isSelectedManagers: boolean;
  usersInboxes: any;
  handleValidateDialog: Function;
  openConfirmationDialog: boolean;
  setOpenConfirmationDialog: Function;
  handleCloseConfirmationDialog: Function;
  countInboxes: any;
  listings: any;
  selectedArea?: any;
}

export const AssignedManager: React.FC<AssignedManagerProps> = (
  props,
): JSX.Element => {
  const [selectedManager, setSelectedManager] = useState({});
  const [associatedManagers, setAssociatedManagers] = useState([
    ...props.List.map((el: any) => el?.userPrivilegesId),
  ]);
  useEffect(() => {
    setAssociatedManagers([
      ...props.List.map((el: any) => el?.userPrivilegesId),
    ]);
  }, [props.List, props.isSelectedManagers]);
  const [openInboxesDialog, setOpenInboxesDialog] = useState(false);
  const isChecked = (id: number) => {
    return associatedManagers.includes(id);
  };
  const handleOpenInboxesDialog = () => {
    setOpenInboxesDialog(true);
  };
  const handleCloseInboxesDialog = () => {
    setOpenInboxesDialog(false);
  };
  const handleValidate = () => {
    if (props.isSelectedManagers) {
      props.handleValidateDialog({
        managerAssignementInboxes: [
          {
            ...selectedManager,
            updatedBy: currentUserStorage?.get()?.username,
          },
        ],
      });
    } else {
      props.handleValidateDialog({
        managerAssignementInboxes: [
          ...props.List.filter((el: any) =>
            isChecked(el?.userPrivilegesId),
          ).map((item: any) => ({
            ...item,
            updatedBy: currentUserStorage?.get()?.username,
          })),
        ],
      });
    }

    props.setOpenConfirmationDialog(false);
  };

  const handleCheckManagers = (
    event: ChangeEvent<HTMLInputElement>,
    checked: boolean,
  ) => {
    let newAssociatedManagers = [...associatedManagers];
    const newValue = parseInt(event.target.value);
    if (!associatedManagers.includes(newValue)) {
      newAssociatedManagers = [...associatedManagers, newValue];
    } else {
      newAssociatedManagers.splice(associatedManagers.indexOf(newValue), 1);
    }
    setAssociatedManagers(newAssociatedManagers);
  };

  const renderItems = (item: any) => {
    return (
      <Grid item>
        <Card style={StyledCard} elevation={0}>
          <Grid
            container
            direction="row"
            spacing={0}
            justify="space-between"
            style={{ flexWrap: 'nowrap' }}
          >
            <Grid item>
              <Grid
                container
                direction="row"
                alignItems="center"
                style={{ flexWrap: 'nowrap' }}
              >
                {props.isSelectedManagers ? (
                  <Grid item>
                    <img
                      src={closeIcon}
                      style={{ cursor: 'pointer' }}
                      data-testId={'delete-icon'}
                      alt={'delete'}
                      onClick={() => {
                        props.setOpenConfirmationDialog(true);
                        setSelectedManager(item);
                      }}
                    />
                  </Grid>
                ) : (
                  <Grid item>
                    <FormGroup key={uniqueId()}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={isChecked(item.userPrivilegesId)}
                            color="primary"
                            value={item.userPrivilegesId}
                            onChange={handleCheckManagers}
                            style={{ marginTop: '-3px', padding: 3 }}
                          />
                        }
                        label={''}
                      />
                    </FormGroup>
                  </Grid>
                )}
                <Grid
                  item
                  style={
                    props.isSelectedManagers ? StyledSpacingGrid : StyledSpacing
                  }
                  data-testId="name"
                  onClick={() => {
                    handleOpenInboxesDialog();
                    setSelectedManager({
                      ...item,
                      inboxes: extractInboxesByUserId(
                        props.usersInboxes,
                        item.userPrivilegesId,
                      ),
                    });
                  }}
                >
                  <span style={StyledSpan}>{item?.sagisName}</span>
                </Grid>
              </Grid>
            </Grid>
            <Grid item>
              <Tooltip
                title={
                  translate(messages.assignedTasksTitle, props) +
                  ': ' +
                  constructTitleOfInboxes(
                    extractInboxesByUserId(
                      props.usersInboxes,
                      item.userPrivilegesId,
                    ),
                  )
                }
                aria-label="add"
              >
                <div style={StyledToolTip}>
                  {
                    extractInboxesByUserId(
                      props.usersInboxes,
                      item.userPrivilegesId,
                    )?.length
                  }
                </div>
              </Tooltip>
            </Grid>
          </Grid>
        </Card>
      </Grid>
    );
  };
  const OpeningManager = props.List.filter(
    (el: any) => el?.userPrivilege?.isOpeningManager,
  );
  const CourtManager = props.List.filter(
    (el: any) => el?.userPrivilege?.isCourtManager,
  );
  const CourtMonitoringManager = props.List.filter(
    (el: any) => el?.userPrivilege?.isCourtMonitoringManager,
  );
  const preOpeningManager = props.List.filter(
    (el: any) => el?.userPrivilege?.isPreOpenManager,
  );
  const solhFelHinManager = props.List.filter(
    (el: any) => el?.userPrivilege?.isSolhFlhin,
  );
  const transactionManager = props.List.filter(
    (el: any) => el?.userPrivilege?.isTransactionManager,
  );
  const isPriorityClaimManager = props.List.filter(
    (el: any) => el?.userPrivilege?.isPriorityClaimsManager,
  );
  const otherManagers = props.List.filter(
    (el: any) =>
      !el?.userPrivilege?.isOpeningManager &&
      !el?.userPrivilege?.isCourtManager &&
      !el?.userPrivilege?.isCourtMonitoringManager &&
      !el?.userPrivilege?.isPreOpenManager &&
      !el?.userPrivilege?.isSolhFlhin &&
      !el?.userPrivilege?.isTransactionManager &&
      !el?.userPrivilege?.isPriorityClaimsManager,
  );

  return (
    <>
      {!isEmpty(OpeningManager) && (
        <>
          <div style={{ marginBottom: 10, marginTop: 12 }}>
            <span style={StyledTitleRoles}>
              {translate(messages.openingManager, props)}
            </span>
          </div>
          <Grid container direction="row" spacing={2}>
            {OpeningManager.map((item: any) => renderItems(item))}
          </Grid>
        </>
      )}

      {!isEmpty(CourtManager) && (
        <>
          <div style={{ marginBottom: 10, marginTop: 12 }}>
            <span style={StyledTitleRoles}>
              {translate(messages.courtManager, props)}
            </span>
          </div>
          <Grid container direction="row" spacing={2}>
            {CourtManager.map((item: any) => renderItems(item))}
          </Grid>
        </>
      )}
      {!isEmpty(CourtMonitoringManager) && (
        <>
          <div style={{ marginBottom: 10, marginTop: 12 }}>
            <span style={StyledTitleRoles}>
              {translate(messages.monitoringManager, props)}
            </span>
          </div>
          <Grid container direction="row" spacing={2}>
            {CourtMonitoringManager.map((item: any) => renderItems(item))}
          </Grid>
        </>
      )}
      {!isEmpty(solhFelHinManager) && (
        <>
          <div style={{ marginBottom: 10, marginTop: 12 }}>
            <span style={StyledTitleRoles}>
              {translate(messages.solhFelHinManager, props)}
            </span>
          </div>
          <Grid container direction="row" spacing={2}>
            {solhFelHinManager.map((item: any) => renderItems(item))}
          </Grid>
        </>
      )}
      {!isEmpty(preOpeningManager) && (
        <>
          <div style={{ marginBottom: 10, marginTop: 12 }}>
            <span style={StyledTitleRoles}>
              {translate(messages.preopenManager, props)}
            </span>
          </div>
          <Grid container direction="row" spacing={2}>
            {preOpeningManager.map((item: any) => renderItems(item))}
          </Grid>
        </>
      )}
      {!isEmpty(transactionManager) && (
        <>
          <div style={{ marginBottom: 10, marginTop: 12 }}>
            <span style={StyledTitleRoles}>
              {translate(messages.transactionManager, props)}
            </span>
          </div>
          <Grid container direction="row" spacing={2}>
            {transactionManager.map((item: any) => renderItems(item))}
          </Grid>
        </>
      )}
      {!isEmpty(isPriorityClaimManager) && (
        <>
          <div style={{ marginBottom: 10, marginTop: 12 }}>
            <span style={StyledTitleRoles}>
              {translate(messages.isPriorityClaimManager, props)}
            </span>
          </div>
          <Grid container direction="row" spacing={2}>
            {isPriorityClaimManager.map((item: any) => renderItems(item))}
          </Grid>
        </>
      )}
      {!isEmpty(otherManagers) && (
        <>
          <div style={{ marginBottom: 10, marginTop: 12 }}>
            <span style={StyledTitleRoles}>
              {translate(messages.otherManagers, props)}
            </span>
          </div>
          <Grid container direction="row" spacing={2}>
            {otherManagers.map((item: any) => renderItems(item))}
          </Grid>
        </>
      )}

      <ConfirmationDialog
        confirmationDialog={props.openConfirmationDialog}
        handleCloseConfirmationDialog={props.handleCloseConfirmationDialog}
        handleValidate={handleValidate}
      />
      <AssignedManagerInboxes
        open={openInboxesDialog}
        onClose={handleCloseInboxesDialog}
        selectedManager={selectedManager}
        validateDialog={props.handleValidateDialog}
        countInboxes={props.countInboxes}
        listings={props.listings}
      />
    </>
  );
};

export default injectIntl(AssignedManager);
